<template>
  <div class="page-background flex-column align-center" :style="props.backgroundColor">
    <div class="page-background_header flex-row align-center justify-between">
      <span
        class="cursor-pointer page-background_header-back"
        :class="{ 'visibility-hidden': props.title === '学后检测' }"
        @click="routerBack"
        ><i class="iconfont icon-back"></i>返回</span
      >

      <!--没有标题-->
      <div v-if="!hasTitle" class="no-title">
        <slot name="noTitleContent"></slot>
      </div>
      <!--有标题-->
      <div v-if="hasTitle" class="page-background_header-title flex-row align-center">
        <div class="ion-text-center title-size mr-5 ml-5">
          {{ props.title }}
        </div>
      </div>
      <div v-if="hasTitle" class="right-bar">
        <div class="right-bar_content">
          <slot
            name="rightTitle"
            :style="{ cursor: !hasModeSwitch ? 'not-allowed' : 'default' }"
          ></slot>
        </div>
      </div>
    </div>
    <div class="page-background_content" @scroll="scrollEvent">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, onMounted, ref } from "vue"
import { useRouter } from "vue-router"
import { useDebounceFn, useScroll } from "@vueuse/core"

interface PropsData {
  title: string
  routerType?: "modal" | "router"
  hasTitle?: string
  backgroundColor?: Record<string, any>
  hasModeSwitch?: boolean
}

const props = defineProps<PropsData>()
const router = useRouter()
const emit = defineEmits(["routerBack", "queryList"])
const isLoad = ref(false)
const hasTitle = ref(true)

function routerBack() {
  if (props.routerType === "modal") {
    emit("routerBack")
    return
  }
  router.back()
}

const scrollQueryFn = useDebounceFn(() => {
  emit("queryList")
}, 500)

function scrollEvent(e: any) {
  const { directions } = useScroll(e.target)
  if (directions.bottom) {
    scrollQueryFn()
  }
}

onMounted(() => {
  hasTitle.value = props.hasTitle !== "essayGenerate"
})
</script>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/theme/ai-theme.less";

.page-background {
  position: relative;
  height: 100%;
  width: 100%;
  //padding-bottom: 5vh;
  background-color: var(--page-background-color, var(--font-white));

  .no-title {
    flex: 1;
    width: 100%;
  }

  &_bg {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: -1;
  }

  &_header {
    width: 100%;
    height: 5rem;
    padding: 0.2rem 3vw 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    position: relative;

    &-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      max-width: 60%;

      .title-size {
        font-size: 1rem;
        font-weight: 600;
      }
    }

    &-back {
      height: 3.2vh;
      z-index: 10;
      font-size: 1.2rem;
      color: var(--text-color, #606266);
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 6vw;
        color: var(--text-color, #606266);
      }
    }

    &-bar {
      width: 1.8vh;
      z-index: 10;
      margin-top: 0.5vh;
    }

    .right-bar {
      height: 100%;
      position: relative;

      &_content {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        vertical-align: middle;
        height: 100%;
        position: relative;
        z-index: 10;
      }
    }
  }

  &_content {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
  }
}
</style>
